import React from 'react';
import { useSelector } from 'react-redux';

export default function useRejectedSelector() {
  const RejectedListData =
    useSelector((state) => state.Rejected.list_data?.rejectedApplications?.content) || []; // List data
  const RejectedViewData = useSelector((state) => state.Rejected.view_data) || []; // List data

  return { RejectedListData, RejectedViewData };
}
